export { Registration } from './registration';
export { registrationModalI18n } from './registration.i18n';
